<app-header-public />

<div [@fadeAnimation]="o.isActivated ? o.activatedRoute : ''">
  <router-outlet #o="outlet" />
</div>

@if (loaderService.loading()) {
 <app-loader type="public" />
}
